<!-- HISTORICO Timeline -->
<div class="bg-white rounded-2xl ring-1 ring-black/5 shadow-md shadow-black/5 p-4 md:p-5">
  <!-- Header -->
  <div class="flex items-center justify-between mb-8">
    <div class="flex items-center gap-3">
      <div>
        <h3 class="text-xl font-bold text-gray-800 tracking-tight">{{ tituloSeccion }}</h3>
      </div>
    </div>
    <button
      class="h-9 w-9 flex items-center justify-center rounded-full bg-[#AE91E3] text-white hover:bg-[#9F7FDB] transition shadow-sm shadow-purple-500/25"
      (click)="abrirModalHistorico()"
      [disabled]="isLocked"
      aria-label="Agregar evento"
    >
      <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path d="M12 6v12M6 12h12" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <!-- Línea de tiempo -->
  <div class="relative pl-2">
    <!-- Mensaje cuando no hay histórico -->
    <div *ngIf="historicosValidos.length === 0" class="text-slate-500 italic text-sm py-2">
      No hay histórico registrado
    </div>

    <!-- Línea vertical morada continua (solo si hay elementos) -->
    <div *ngIf="historicosValidos.length > 0" class="absolute left-[16px] top-[12px] bottom-[12px] w-[2px] bg-purple-200"></div>

    <!-- Grupos del histórico -->
    <div *ngFor="let hist of historicosValidos; let histIndex = index" class="relative pb-6 last:pb-0">
      <!-- Nodo morado clickeable -->
      <button
        type="button"
        (click)="toggleHistoricoCollapse(histIndex)"
        class="absolute left-0 top-0 h-6 w-6 rounded-full bg-[#D2BFF5] border-3 border-solid border-[#F1E9FF] z-10 cursor-pointer hover:bg-[#C4A8F0] transition-colors flex items-center justify-center"
        [attr.aria-expanded]="!isHistoricoCollapsed(histIndex)"
        [attr.aria-label]="isHistoricoCollapsed(histIndex) ? 'Expandir ' + hist.titulo : 'Colapsar ' + hist.titulo"
      >
        <svg
          class="w-3 h-3 text-purple-700 transition-transform duration-200"
          [style.transform]="isHistoricoCollapsed(histIndex) ? 'rotate(-90deg)' : 'rotate(0deg)'"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <!-- Contenido AL LADO del nodo -->
      <div class="ml-7">
        <!-- Título padre con botones de acción -->
        <div class="flex items-start justify-between mb-4">
          <h4
            class="text-sm font-semibold text-slate-900 leading-6 m-0 cursor-pointer hover:text-purple-700 transition-colors"
            (click)="toggleHistoricoCollapse(histIndex)"
          >
            {{ hist.titulo }}
            <span class="text-xs text-slate-400 font-normal ml-1">({{ hist.eventos.length }})</span>
          </h4>

          <!-- Botones editar/eliminar (solo si no está bloqueado) -->
          <div *ngIf="!isLocked" class="flex items-center gap-1.5 ml-3 flex-shrink-0">
            <!-- Botón Editar -->
            <button
              (click)="abrirModalEditarHistorico(hist)"
              class="p-1.5 text-slate-500 hover:text-purple-600 hover:bg-slate-50 rounded-md transition"
              aria-label="Editar histórico"
              type="button"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </button>

            <!-- Botón Eliminar -->
            <button
              (click)="eliminarHistorico(hist)"
              class="p-1.5 text-slate-500 hover:text-slate-700 hover:bg-slate-50 rounded-md transition"
              aria-label="Eliminar histórico"
              type="button"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Eventos hijos debajo del título (colapsables) -->
        <div
          class="overflow-hidden transition-all duration-300 ease-in-out"
          [class.max-h-0]="isHistoricoCollapsed(histIndex)"
          [class.opacity-0]="isHistoricoCollapsed(histIndex)"
          [class.max-h-[2000px]]="!isHistoricoCollapsed(histIndex)"
          [class.opacity-100]="!isHistoricoCollapsed(histIndex)"
        >
          <ul class="space-y-3">
            <li
              *ngFor="let evento of hist.eventos; let eventoIndex = index"
              class="grid gap-3 text-sm group"
              [class.grid-cols-[70px_1fr_auto]]="!isLocked"
              [class.grid-cols-[70px_1fr]]="isLocked"
            >
            <!-- Fecha -->
            <span class="text-slate-600 text-xs">
              {{ evento.fecha | date : 'dd/MM/yy' }}
            </span>

            <!-- Contenido -->
            <div>
              <span class="font-semibold text-slate-900">{{ evento.nombre }}</span>
              <span class="text-slate-500 text-xs" *ngIf="evento.descripcion"> · {{ evento.descripcion }}</span>

              <!-- Hipervínculo al paraclínico -->
              <div *ngIf="evento.paraclinico" class="mt-1.5 flex items-center gap-1.5">
                <svg
                  class="w-4 h-4 text-purple-600 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <button
                  (click)="abrirModalVerParaclinico(evento.paraclinico)"
                  class="text-sm text-purple-600 hover:text-purple-800 hover:underline font-medium transition"
                >
                  {{ evento.paraclinico.nombre || 'Sin nombre' }}
                </button>
              </div>
            </div>

            <!-- Botón eliminar evento (solo si no está bloqueado) -->
            <button
              *ngIf="!isLocked"
              (click)="eliminarEvento(hist, eventoIndex)"
              class="self-start opacity-0 group-hover:opacity-100 p-1 text-slate-400 hover:text-slate-600 transition-opacity"
              aria-label="Eliminar evento"
              type="button"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Ver Paraclínico - Se abre en el componente padre para mostrarse a pantalla completa -->

<!-- Modal de Confirmación (Custom) -->
<div
  *ngIf="modalConfirmacionAbierto"
  class="fixed inset-0 z-[1220] flex items-center justify-center bg-black/40 backdrop-blur-[1px]"
>
  <div
    class="relative w-full max-w-md bg-white rounded-2xl shadow-xl shadow-black/10 ring-1 ring-black/5 overflow-hidden"
    role="dialog"
    aria-modal="true"
  >
    <!-- Close Button -->
    <button
      class="absolute top-3 right-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/80 hover:bg-white text-slate-500 hover:text-slate-700 ring-1 ring-black/5 transition"
      (click)="cerrarModalConfirmacion()"
      aria-label="Cerrar"
    >
      <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path d="M6 6l12 12M18 6L6 18" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>

    <!-- Content -->
    <div class="px-6 pt-6 pb-4 text-center">
      <!-- Ícono Advertencia -->
      <div class="mx-auto mb-4">
        <svg class="w-12 h-12 mx-auto text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>

      <!-- Título -->
      <h3 class="text-lg font-semibold text-slate-900 mb-2">
        {{ getTituloConfirmacion() }}
      </h3>

      <!-- Mensaje -->
      <p class="text-sm text-slate-600 leading-relaxed">
        {{ getMensajeConfirmacion() }}
      </p>

      <!-- Advertencia Extra (si es último evento) -->
      <div
        *ngIf="mostrarAdvertenciaExtra()"
        class="mt-4 mx-auto max-w-sm bg-slate-50 border-l-2 border-slate-300 p-3 rounded"
      >
        <div class="flex items-start gap-2 text-left">
          <svg
            class="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <p class="text-xs text-slate-600">Este histórico quedará sin eventos y será eliminado automáticamente.</p>
        </div>
      </div>

      <!-- Mensaje de no reversible -->
      <p class="text-xs text-slate-500 mt-3">Esta acción no se puede deshacer.</p>
    </div>

    <!-- Footer -->
    <div class="px-6 pb-6 pt-2 flex items-center justify-end gap-3">
      <button
        type="button"
        class="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 transition text-sm font-medium"
        (click)="cerrarModalConfirmacion()"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="px-4 py-2 rounded-lg bg-slate-600 hover:bg-slate-700 text-white transition text-sm font-medium"
        (click)="confirmarAccion()"
      >
        Eliminar
      </button>
    </div>
  </div>
</div>

